import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

export const numberRegexOptions: RegexOption[] = [
  {
    type: 'number',
    display: 'Number',
    code: 'X, X.X, X,X',
    icon: 'Hash',
    regex: '^-?\\d+(?:[.,]\\d+)?$',
    examples: ['0', '42', '1.5', '1,5', '-123.45', '-123,45'],
  },
  {
    type: 'number-decimal-point',
    display: 'Decimal Point',
    code: 'X.XX',
    icon: 'Hash',
    regex: '^\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?$',
    examples: ['0.00', '1.50', '1,234.56', '1,000,000.00'],
  },
  {
    type: 'number-decimal-comma',
    display: 'Comma Separator',
    code: 'X,XX',
    icon: 'Hash',
    regex: '^\\d{1,3}(?:\\.\\d{3})*(?:,\\d{2})?$',
    examples: ['0,00', '1,50', '1.234,56', '1.000.000,00'],
  },
  {
    type: 'number-integer',
    display: 'Integer',
    code: 'X',
    icon: 'Hash',
    regex: '^\\d+$',
    examples: ['0', '42', '12345'],
  },
  {
    type: 'number-with-thousands',
    display: 'Thousands Separator',
    code: 'X,XXX,XXX',
    icon: 'Hash',
    regex: '^\\d{1,3}(?:,\\d{3})*$',
    examples: ['1,234', '1,000,000', '42'],
  },
  {
    type: 'number-scientific',
    display: 'Scientific Notation',
    code: 'X.XXeX',
    icon: 'Hash',
    regex: '^[+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?$',
    examples: ['1.23e+5', '1.23e-5', '1.23E10'],
  },
  {
    type: 'number-negative',
    display: 'Negative',
    code: '-X.XX',
    icon: 'Hash',
    regex: '^-\\d+(?:\\.\\d+)?$',
    examples: ['-42', '-1.23', '-1000'],
  },
  {
    type: 'number-positive',
    display: 'Positive',
    code: '+X.XX',
    icon: 'Hash',
    regex: '^\\+?\\d+(?:\\.\\d+)?$',
    examples: ['+42', '+1.23', '1000'],
  },
  {
    type: 'number-percentage',
    display: 'Percentage',
    code: 'X%',
    icon: 'Percent',
    regex: '^\\d+(?:\\.\\d+)?%$',
    examples: ['42%', '99.9%', '0.01%'],
  },
  {
    type: 'number-range',
    display: 'Range',
    code: 'X.XX-Y.YY',
    icon: 'Hash',
    regex: '^-?\\d+(?:\\.\\d+)?\\s*-\\s*-?\\d+(?:\\.\\d+)?$',
    examples: ['-1-100', '-0.5-1.5', '-1000-2000'],
  },
  {
    type: 'number-fraction',
    display: 'Fraction',
    code: 'X/Y',
    icon: 'Hash',
    regex: '^\\d+\\/\\d+$',
    examples: ['1/2', '3/4', '16/9'],
  },
];
